// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    projectId: 'sgintegrador',
    appId: '1:492200189079:web:2af52f7213f477c3131dd2',
    databaseURL: 'https://sgintegrador-default-rtdb.firebaseio.com',
    storageBucket: 'sgintegrador.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyCJZfXAqjLimOcvYpGzgLoUjFkaOa540g0',
    authDomain: 'sgintegrador.firebaseapp.com',
    messagingSenderId: '492200189079',
    measurementId: 'G-QNM31S3D4P',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
